/*
 * @Author: Lim 
 * @Date: 2020-09-10 09:48:22 
 * @Last Modified by: Lim
 * @Last Modified time: 2020-10-21 10:03:00
 */
import React, { useState, useEffect, useRef } from 'react';
import style from "./Input.module.scss";
import cn from 'classnames';
import { initConfig, unitFilter } from '../common';

export default (props) => {
    /**
     * default
     */
    const defaultConfig = {
        inputType: 'input',
        value : '',
        placeholder : '',
        height : '28',
        width : '100%',
        errorShow: false,
        errorText : '报错信息',
        disable : false,
        keyUpType : '',
        blurType : '',
        errorType :'0',
        maxLength : '',
        autocomplete : false,
        keyCode : '',
        subscribeKeyCode(){},
        focus(){},
        blur(){},
        change(){},
        keyUp(){},
        keyDown(){},
    }
    /**
     * initial
     * 数据对比
     * 单位过滤
     * 正则( 失焦校验 & 实施校验 )
     */
    const { 
        inputType,
        value,
        placeholder,
        height,
        errorShow,
        width,
        errorText,
        disable,
        keyUpType,
        blurType,
        errorType,
        maxLength,
        autocomplete,
        keyCode,
        subscribeKeyCode,
        focus,
        blur,
        change,
        keyUp,
        keyDown,
    } = initConfig( defaultConfig, props.config );

    const defaultWidth = unitFilter ( width );
    const defaultHeight = unitFilter ( height );
    const defaultMaxLength = parseInt ( maxLength );
    const defaultKeyCode = keyCode === '' ? keyCode : parseInt ( keyCode );
    
    const keyupRegs = {
        numReg : /(-|\d){1}[\d]*/,
        mobileReg : /(1[3-9]\d{0,9}|1)/, 
        wechatReg : /([-\_a-zA-Z](([-\_]|\w){0,19})| 1[3-9]\d{0,9}|([1-9]\d{0,10})| (-\_a-zA-Z|1))/,
        qqReg : /([1-9]\d{0,9}|([1-9]))/,
        emailReg : /((\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*)|(\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w)|(\w+([-+.]\w+)*@\w+([-.]\w+)*\.)|(\w+([-+.]\w+)*@\w+([-.]|\w+)*)|(\w+([-+.]\w+)*@\w)|(\w+([-+.]\w+)*@)|\w+([-+.]\w+)*|\w)/,
        phoneReg : /((0\d{2,3}-)\d{0,8}|(0\d{2,3}-)|(0\d{0,3}))/
    };
    const blurRegs = {
        numReg : /^(-|\d){1}[\d]*$/,
        mobileReg : /^1[3-9]\d{9}$/,
        wechatReg : /(^[-\_a-zA-Z](([-\_]|\w){5,19})$)|(^([1-9]\d{4,9})$)|(^1[3-9]\d{9}$)/,
        qqReg : /(^([1-9]\d{4,9})$)|(^1[3-9]\d{9}$)/,
        emailReg : /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
        phoneReg : /^(0\d{2,3}-?)?\d{7,8}$/,
        blankReg : /\S/
    };
    /**
     * state
     * 输入框默认值
     * 展示报错信息
     */
    const [ defalutVal, setDefalutValue ] = useState( value );
    const [ errorTip, setErrorTip ] = useState( false );
     /**
     * refs
     * 输入框
     */
    const inputContainer = useRef();
    /**
     * subscribe
     * 订阅点击监听
     */
    const _subscribeKeyCode = e => {
        if( e.keyCode === defaultKeyCode ){
            subscribeKeyCode( inputContainer.current.value )
        }
    }
     /**
     * didmount & update & unMount
     * didmount & unMount 按键监听
     * update 报错提示开启隐藏
     * update props.value动态改变
     * update setDefalutValue回调
     */
    useEffect(() =>{
        if( defaultKeyCode !== '' ){
            inputContainer.current.addEventListener("keydown", _subscribeKeyCode);
            return () => {
                inputContainer.current.removeEventListener("keydown", _subscribeKeyCode);
            }
        }
    },[])
    useEffect(() =>{
        setErrorTip( errorShow )
    },[ errorShow ])
    useEffect(() =>{
        setDefalutValue( value )
    },[ value ])
    useEffect(() =>{
        change( defalutVal )
    },[ defalutVal ])
     /**
     * Func
     * 聚焦
     * 按键按下
     * 按键抬起
     * 失焦
     * 内容发生变化
     * 实时检验
     * 获取报错信息的marginLeft值
     */
    const _onFocus = () => {
        setErrorTip( false );
        focus( defalutVal );
    }
    const _onKeyDown = () => {
        keyDown( defalutVal );
    }
    const _onKeyUp = () => {
        // 输入类型过滤方法
        if( keyUpType !== "" ){
            const value = _RealTimeVerify()
            setDefalutValue( value );
            keyUp( value );
        }else{
            keyUp( defalutVal );
        }
    }
    const _onBlur = () => {
        let flag;
        if( blurType ) {
            const reg = blurRegs[blurType+'Reg'];
            flag = reg.test( defalutVal );
            if( flag === false ) {
                setErrorTip( true )
                blur( defalutVal, false );
            }else{
                setErrorTip( false )
                blur( defalutVal, true );
            }
        }else{
            blur( defalutVal );
        }
    }
    const _onChange = () => {
        let value = '';
        value = inputContainer.current.value;
        setDefalutValue( value );
    }
    const _RealTimeVerify = () => {
        const reg = keyupRegs[keyUpType+'Reg'];
        let newValue = '';
        newValue = reg.exec( defalutVal ) !== null ? reg.exec( defalutVal )[0] : "";
        return newValue;
    }
    const _getMarginLeft = (str) => {
        let div = document.createElement('div');
        div.id = "moment";
        div.style = "padding:0 10px; display:inline-block; position:fixed; top:-99px"
        div.innerHTML= str;
        document.body.append(div);
        let moment = document.getElementById("moment");
        let marginLeft = -(parseInt(moment.offsetWidth)/2);
        moment.parentNode.removeChild(moment)
        return marginLeft;
    }
     /**
     * DOM
     */
    const config = {
        style: { height: defaultHeight, width: defaultWidth, resize: defaultHeight > 28 ? "none" : ""},
        placeholder: placeholder,
        className:  cn( errorTip !== false ? style.error : "" ),
        disabled: disable,
        maxLength: defaultMaxLength,
        ref: inputContainer,
        onFocus: _onFocus,
        onBlur: _onBlur,
        onKeyDown: _onKeyDown,
        onKeyUp: _onKeyUp,
        onChange: _onChange
    }
    return (
        <span className = { style.main } style = { config.style }>
            <span className = { style.input_box } style = { config.style }>   
                {
                    errorType == 1 &&  errorTip === true ? 
                    <span className={ style.bubble } style = {{ marginLeft : _getMarginLeft(errorText) }}>{ errorText }</span>
                    : ""
                }
                {
                    inputType === "textarea" ?
                    <textarea { ...config }  value={ defalutVal }>{ defalutVal }</textarea> :
                    <input 
                        value = { defalutVal } 
                        autoComplete = { autocomplete === true ? 'on' : 'off'}
                        { ...config }
                    type="text"/>
                }
            </span>
            {
                errorType == 2 && errorTip === true ? 
                <span className={ style.error_text }>{ errorText }</span>: ""
            }
        </span>
    )
}
